import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';

// Components
import JobsTable from '../../jobs/JobsTable';
import LoadingSpinner from '../../../utils/LoadingSpinner';

// Actions
import { get_deferred_elements, retry_deferred } from '../../../../actions/deferredActions';

const DeferredElements = ({ queue }) => {
	const dispatch = useDispatch();

	const { deferred_elements_loading, deferred_elements } = useSelector(state => state.deferred);

	const [start, setStart] = useState(0);
	const [end, setEnd] = useState(20);

	useEffect(() => {
		const filters = {
			resource: queue.resource,
			speed: queue.speed,
			start: start,
			end: end
		};
		if (queue.organization) filters.organization = queue.organization;
		dispatch(get_deferred_elements(filters));
	}, [queue, start]);

	const handleRetry = (jobId) => {
		const filters = {
			resource: queue.resource,
			speed: queue.speed,
			job: jobId,
			force: 'true'
		};
		if (queue.organization) filters.organization = queue.organization;
		dispatch(retry_deferred(filters));
	};

	return (
		<Card className='shadow-sm mb-3 card-border'>
			<Card.Body>
				<Card.Title className='text-center' as='h6'>
					Deferred Elements — {queue.queue || queue.deferred}
					<span className='text-muted ms-2'>({deferred_elements.size || 0} total)</span>
				</Card.Title>

				{deferred_elements_loading
					? <LoadingSpinner loadingMsg='Loading deferred elements' />
					: <JobsTable
						loading={deferred_elements_loading}
						jobsType='workers'
						jobs={deferred_elements.elements || []}
						noJobsMsg='No deferred elements found'
					/>
				}

				<div className='d-flex justify-content-center gap-2 mt-2'>
					<Button size='sm' variant='outline-secondary' disabled={start === 0} onClick={() => { setStart(Math.max(0, start - 20)); setEnd(Math.max(20, end - 20)); }}>
						<i className='bi bi-chevron-left'></i> Previous
					</Button>
					<Button size='sm' variant='outline-secondary' disabled={(deferred_elements.elements || []).length < 20} onClick={() => { setStart(start + 20); setEnd(end + 20); }}>
						Next <i className='bi bi-chevron-right'></i>
					</Button>
				</div>
			</Card.Body>
		</Card>
	);
}

DeferredElements.propTypes = {
	queue: PropTypes.object.isRequired
}

export default DeferredElements;
